import React from 'react';
import { Textfit } from 'react-textfit';
import { bodyFontSizesBOH, titleFontSizesBOH, useLastUpdated } from '../../../helpers/utils';
import { usePager } from '../../../helpers/pagination';
import PageIndicator from '../../Common/PageIndicator';
import SideBar from '../../Common/SideBar';
import Row from './Row';
import './SpeedOfService.scss';
const DAYPART_LABELS = {
  breakfast: 'Breakfast',
  lunch: 'Lunch',
  snack: 'Snack',
  dinner: 'Dinner',
  latenight: 'Late night'
};
const SpeedOfService = ({
  data,
  duration,
  playing,
  metadata,
  text
}) => {
  var _metadata$accent_colo, _metadata$results, _data$top$slice, _data$top;
  const accent_color = (_metadata$accent_colo = metadata.accent_color) !== null && _metadata$accent_colo !== void 0 ? _metadata$accent_colo : '#000';
  const logo = metadata.logo;
  const timezone = data === null || data === void 0 ? void 0 : data.timezone;
  const results = (_metadata$results = metadata.results) !== null && _metadata$results !== void 0 ? _metadata$results : 10;
  const ranking = (_data$top$slice = (_data$top = data.top) === null || _data$top === void 0 ? void 0 : _data$top.slice(0, results)) !== null && _data$top$slice !== void 0 ? _data$top$slice : [];
  const own = data.own;
  const isOwnInRanking = (own === null || own === void 0 ? void 0 : own.ranking) <= results;
  const hide_poweredbyupshow = metadata.hide_poweredbyupshow;
  const [page, pageIdx, pages] = usePager(ranking, duration * 1000, playing);
  const lastUpdated = useLastUpdated(page, timezone);
  const bodyLastUpdated = `${DAYPART_LABELS[metadata.boh_daypart]} drive-thru SOS as of ${lastUpdated ? lastUpdated.toFormat('MM/dd') : 'N/A'} at ${lastUpdated ? lastUpdated.toFormat('t') : 'N/A'}`;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "sos-ticket-container",
    style: {
      color: text.body_color,
      fontFamily: text.body_font_family,
      fontSize: bodyFontSizesBOH.medium
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "width-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "title",
    style: {
      color: text.title_color,
      fontFamily: text.title_font_family,
      fontSize: titleFontSizesBOH.medium
    }
  }, /*#__PURE__*/React.createElement(Textfit, {
    key: `title ${text.title_font_family}`,
    mode: "single",
    min: titleFontSizesBOH.small,
    max: titleFontSizesBOH.large
  }, text.title)), /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, /*#__PURE__*/React.createElement(Textfit, {
    key: `description ${text.body_font_family}`,
    mode: "single",
    min: 25,
    max: bodyFontSizesBOH.small
  }, bodyLastUpdated))), /*#__PURE__*/React.createElement("div", {
    className: "sos-ticket-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-row list-header",
    style: {
      backgroundColor: accent_color,
      color: text.accent_color,
      fontFamily: text.title_font_family
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "left"
  }, "Location"), /*#__PURE__*/React.createElement("p", {
    className: "center"
  }, "Goal"), /*#__PURE__*/React.createElement("p", {
    className: "center"
  }, "Current"), /*#__PURE__*/React.createElement("p", {
    className: "right"
  }, "Variation")), page.map((loc, index) => /*#__PURE__*/React.createElement(Row, {
    key: `${loc.location}-${index}`,
    location: loc,
    own: own,
    accent_color: accent_color
  })), !!own && !isOwnInRanking && /*#__PURE__*/React.createElement(Row, {
    key: `${own.location}`,
    location: own,
    accent_color: accent_color,
    own: own
  })), pages.length > 1 && /*#__PURE__*/React.createElement(PageIndicator, {
    pages: pages,
    current: pageIdx,
    selectedColor: accent_color
  }))), /*#__PURE__*/React.createElement(SideBar, {
    accent_color: accent_color,
    accent_text_color: text.accent_color,
    logo: logo,
    text: text.message_board,
    fontFamily: text.title_font_family,
    hide_poweredbyupshow: hide_poweredbyupshow
  }));
};
export default SpeedOfService;